
import { Component } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { Venue } from '@/interfaces/models/Venue';

@Component({
  components: { VFormBuilder },
})
export default class PaymentForm extends mixins(StackedForm) {
  public $refs!: {
    baseForm: InstanceType<typeof VFormBuilder> & { form: any };
    paymentForm: InstanceType<typeof VFormBuilder> & { form: any };
    preorderForm: InstanceType<typeof VFormBuilder> & { form: any };
    deliveryForm: InstanceType<typeof VFormBuilder> & { form: any };
    ccForm: InstanceType<typeof VFormBuilder> & { form: any };
    ppForm: InstanceType<typeof VFormBuilder> & { form: any };
    sepaForm: InstanceType<typeof VFormBuilder> & { form: any };
    sbForm: InstanceType<typeof VFormBuilder> & { form: any };
    apForm: InstanceType<typeof VFormBuilder> & { form: any };
    gpForm: InstanceType<typeof VFormBuilder> & { form: any };
    walleeCredentials: InstanceType<typeof VFormBuilder> & { form: any };
    walleePaymentConfs: InstanceType<typeof VFormBuilder> & { form: any };
    worldlineCredentials: InstanceType<typeof VFormBuilder> & { form: any };
    datatransCredentials: InstanceType<typeof VFormBuilder> & { form: any };
    adyenCredentials: InstanceType<typeof VFormBuilder> & { form: any };
    neptingCredentials: InstanceType<typeof VFormBuilder> & { form: any };
  };

  public adyenEnabled: boolean = false;
  public adyenPaypalEnabled: boolean = false;

  get initValues() {
    return this.initialValues as Venue;
  }

  get generalItems() {
    return [
      {
        name: 'currency',
        type: InputType.Select,
        default: 'EUR',
        label: 'venue.form.currency',
        rules: 'required',
        items: this.currencies,
      },
      {
        name: 'webAppUrl',
        type: InputType.Text,
        label: 'venue.form.webAppUrl',
      },
      {
        name: 'supplier',
        type: InputType.Text,
        label: 'venue.form.supplier',
      },
      { name: 'provisionRate', type: InputType.Text, label: 'venue.form.provisionRate', default: '0' },
      {
        name: 'provisionFixedRate',
        type: InputType.Text,
        default: '0',
        label: 'venue.form.provisionFixedRate',
      },
      {
        name: 'vrAccessToken',
        type: InputType.Text,
        default: '',
        label: 'venue.form.vrAccessToken',
        autocomplete: 'off',
      },
      {
        name: 'vrPaymentEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.vrPaymentEnabled',
      },
      {
        name: 'ppV2Enabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.ppV2Enabled',
      },
      {
        name: 'ppFullIntegrationEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.ppFullIntegrationEnabled',
      },
      {
        name: 'walleeEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.walleeEnabled',
      },
      {
        name: 'tacEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.tacEnabled',
      },
      {
        name: 'comoLoyaltyEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.comoLoyaltyEnabled',
      },
    ];
  }

  get paymentItems() {
    return [
      { name: 'ccvApikey', type: InputType.Text, label: 'venue.form.ccvApikey', autocomplete: 'off' },
      { name: 'comoApiKey', type: InputType.Text, label: 'venue.form.comoApiKey', autocomplete: 'off' },
      { name: 'paymentEnabled', type: InputType.Checkbox, label: 'venue.form.paymentEnabled' },
      { name: 'cashEnabled', type: InputType.Checkbox, label: 'venue.form.cashEnabled' },
      { name: 'posEnabled', type: InputType.Checkbox, label: 'venue.form.posEnabled' },
      { name: 'sepaEnabled', type: InputType.Checkbox, label: 'venue.form.sepaEnabled' },
      { name: 'ccEnabled', type: InputType.Checkbox, label: 'venue.form.ccEnabled' },
      { name: 'sbEnabled', type: InputType.Checkbox, label: 'venue.form.sbEnabled' },
      { name: 'ppEnabled', type: InputType.Checkbox, label: 'venue.form.ppEnabled' },
      { name: 'gpEnabled', type: InputType.Checkbox, label: 'venue.form.gpEnabled' },
      { name: 'apEnabled', type: InputType.Checkbox, label: 'venue.form.apEnabled' },
      { name: 'rekaEnabled', type: InputType.Checkbox, label: 'venue.form.rekaEnabled' },
      { name: 'twintEnabled', type: InputType.Checkbox, label: 'venue.form.twintEnabled' },
      { name: 'pfEnabled', type: InputType.Checkbox, label: 'venue.form.pfEnabled' },
      { name: 'pfcEnabled', type: InputType.Checkbox, label: 'venue.form.pfcEnabled' },
      { name: 'bcEnabled', type: InputType.Checkbox, label: 'venue.form.bcEnabled' },
      { name: 'lchEnabled', type: InputType.Checkbox, label: 'venue.form.lchEnabled' },
      { name: 'wcEnabled', type: InputType.Checkbox, label: 'venue.form.wcEnabled' },
      { name: 'alipayEnabled', type: InputType.Checkbox, label: 'venue.form.alipayEnabled' },
      { name: 'cwlEnabled', type: InputType.Checkbox, label: 'venue.form.cwlEnabled' },
      { name: 'ccvEnabled', type: InputType.Checkbox, label: 'venue.form.ccvEnabled' },
      { name: 'zeroPaymentEnabled', type: InputType.Checkbox, default: false, label: 'venue.form.zeroPaymentEnabled' },
      { name: 'worldlineEnabled', type: InputType.Checkbox, label: 'venue.form.worldlineEnabled' },
      {
        name: 'wlApplePayEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlApplePayEnabled',
      },
      {
        name: 'wlApplePayMobileEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlApplePayMobileEnabled',
      },
      {
        name: 'wlGooglePayEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlGooglePayEnabled',
      },
      {
        name: 'wlGooglePayMobileEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlGooglePayMobileEnabled',
      },
      { name: 'wlCardEnabled', type: InputType.Checkbox, label: 'venue.form.wlCardEnabled' },
      { name: 'wlCardMobileEnabled', type: InputType.Checkbox, label: 'venue.form.wlCardMobileEnabled' },
      { name: 'woltPaymentEnabled', type: InputType.Checkbox, default: false, label: 'venue.form.woltPaymentEnabled' },
      {
        name: 'uberEatsPaymentEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.uberEatsPaymentEnabled',
      },
      { name: 'jetPaymentEnabled', type: InputType.Checkbox, default: false, label: 'venue.form.jetPaymentEnabled' },
      { name: 'kostCardPaymentEnabled', type: InputType.Checkbox, label: 'venue.form.kostCardPaymentEnabled' },
      {
        name: 'ctCreditCardPaymentEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.ctCreditCardPaymentEnabled',
      },
      {
        name: 'bankTransferPaymentEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.bankTransferPaymentEnabled',
      },
      {
        name: 'dataTransEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.dataTransEnabled',
      },
      {
        name: 'piggyGiftCardPaymentEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.piggyGiftCardEnabled',
      },
      {
        name: 'piggyPrepaidBalancePaymentEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.piggyPrepaidBalanceEnabled',
      },
      {
        name: 'adyenEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.adyenEnabled',
        change: this.onAdyenEnabledChange,
      },
      { name: 'neptingEnabled', type: InputType.Checkbox, label: 'venue.form.neptingEnabled' },
    ];
  }

  get preorderPaymentItems() {
    return [
      { name: 'ccPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.ccEnabled' },
      { name: 'ppPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.ppEnabled' },
      { name: 'gpPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.gpEnabled' },
      { name: 'apPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.apEnabled' },
      { name: 'cashPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.cashEnabled' },
      { name: 'sepaPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.sepaEnabled' },
      { name: 'rekaPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.rekaEnabled' },
      { name: 'twintPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.twintEnabled' },
      { name: 'pfPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.pfEnabled' },
      { name: 'pfcPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.pfcEnabled' },
      { name: 'bcPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.bcEnabled' },
      { name: 'lchPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.lchEnabled' },
      { name: 'wcPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.wcEnabled' },
      { name: 'alipayPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.alipayEnabled' },
      { name: 'cwlPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.cwlEnabled' },
      { name: 'ccvPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.ccvEnabled' },
      { name: 'zeroPaymentPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.zeroPaymentEnabled' },
      { name: 'worldlinePreorderEnabled', type: InputType.Checkbox, label: 'venue.form.worldlineEnabled' },
      {
        name: 'wlApplePayPreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlApplePayEnabled',
      },
      {
        name: 'wlApplePayMobilePreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlApplePayMobileEnabled',
      },
      {
        name: 'wlGooglePayPreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlGooglePayEnabled',
      },
      {
        name: 'wlGooglePayMobilePreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlGooglePayMobileEnabled',
      },
      {
        name: 'wlCardPreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlCardEnabled',
      },
      { name: 'wlCardMobilePreorderEnabled', type: InputType.Checkbox, label: 'venue.form.wlCardMobileEnabled' },
      { name: 'woltPaymentPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.woltPaymentEnabled' },
      { name: 'uberEatsPaymentPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.uberEatsPaymentEnabled' },
      { name: 'jetPaymentPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.jetPaymentEnabled' },
      {
        name: 'kostCardPaymentPreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.kostCardPaymentEnabled',
      },
      {
        name: 'ctCreditCardPaymentPreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.ctCreditCardPaymentEnabled',
      },
      {
        name: 'bankTransferPaymentPreorderEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.bankTransferPaymentEnabled',
      },
      {
        name: 'tacPreorderEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.tacEnabled',
      },
      {
        name: 'dataTransPreorderEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.dataTransEnabled',
      },
      {
        name: 'piggyGiftCardPaymentPreorderEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.piggyGiftCardEnabled',
      },
      {
        name: 'piggyPrepaidBalancePaymentPreorderEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.piggyPrepaidBalanceEnabled',
      },
      {
        name: 'adyenPreorderEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.adyenEnabled',
      },
      { name: 'neptingPreorderEnabled', type: InputType.Checkbox, label: 'venue.form.neptingEnabled' },
    ];
  }

  get deliveryPaymentItems() {
    return [
      { name: 'ccDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.ccEnabled' },
      { name: 'ppDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.ppEnabled' },
      { name: 'gpDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.gpEnabled' },
      { name: 'apDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.apEnabled' },
      { name: 'cashDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.cashEnabled' },
      { name: 'sepaDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.sepaEnabled' },
      { name: 'rekaDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.rekaEnabled' },
      { name: 'twintDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.twintEnabled' },
      { name: 'pfDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.pfEnabled' },
      { name: 'pfcDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.pfcEnabled' },
      { name: 'bcDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.bcEnabled' },
      { name: 'lchDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.lchEnabled' },
      { name: 'wcDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.wcEnabled' },
      { name: 'alipayDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.alipayEnabled' },
      { name: 'cwlDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.cwlEnabled' },
      { name: 'ccvDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.ccvEnabled' },
      { name: 'zeroPaymentDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.zeroPaymentEnabled' },
      { name: 'worldlineDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.worldlineEnabled' },
      {
        name: 'wlApplePayDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlApplePayEnabled',
      },
      {
        name: 'wlApplePayMobileDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlApplePayMobileEnabled',
      },
      {
        name: 'wlGooglePayDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlGooglePayEnabled',
      },
      {
        name: 'wlGooglePayMobileDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.wlGooglePayMobileEnabled',
      },
      { name: 'wlCardDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.wlCardEnabled' },
      { name: 'wlCardMobileDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.wlCardMobileEnabled' },
      { name: 'woltPaymentDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.woltPaymentEnabled' },
      { name: 'uberEatsPaymentDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.uberEatsPaymentEnabled' },
      { name: 'jetPaymentDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.jetPaymentEnabled' },
      {
        name: 'kostCardPaymentDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.kostCardPaymentEnabled',
      },
      {
        name: 'ctCreditCardPaymentDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.ctCreditCardPaymentEnabled',
      },
      {
        name: 'bankTransferPaymentDeliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.bankTransferPaymentEnabled',
      },
      {
        name: 'tacDeliveryEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.tacEnabled',
      },
      {
        name: 'dataTransDeliveryEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.dataTransEnabled',
      },
      {
        name: 'piggyGiftCardPaymentDeliveryEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.piggyGiftCardEnabled',
      },
      {
        name: 'piggyPrepaidBalancePaymentDeliveryEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.piggyPrepaidBalanceEnabled',
      },
      {
        name: 'adyenDeliveryEnabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.adyenEnabled',
      },
      { name: 'neptingDeliveryEnabled', type: InputType.Checkbox, label: 'venue.form.neptingEnabled' },
    ];
  }

  get ccCredentialItems() {
    return [
      { name: 'ccMerchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' },
      { name: 'ccSecretKey', type: InputType.Text, label: 'venue.form.secretKey', autocomplete: 'off' },
    ];
  }

  get apCredentialItems() {
    return [{ name: 'apMerchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' }];
  }

  get gpCredentialItems() {
    return [{ name: 'gpMerchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' }];
  }

  get ppCredentialItems() {
    return [
      { name: 'ppMerchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' },
      { name: 'ppSecretKey', type: InputType.Text, label: 'venue.form.secretKey', autocomplete: 'off' },
      { name: 'ppEmail', type: InputType.Text, label: 'venue.form.ppEmail', rules: 'email', autocomplete: 'off' },
    ];
  }

  get sbCredentialItems() {
    return [{ name: 'sbMerchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' }];
  }

  get sepaCredentialItems() {
    return [
      { name: 'sepaMerchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' },
      { name: 'sepaSecretKey', type: InputType.Text, label: 'venue.form.secretKey', autocomplete: 'off' },
      { name: 'sepaMerchantName', type: InputType.Text, label: 'venue.form.merchantName', autocomplete: 'off' },
      { name: 'sepaCreditorId', type: InputType.Text, label: 'venue.form.creditorId', autocomplete: 'off' },
    ];
  }

  get currencies() {
    return [
      { value: 'EUR', text: this.$t('currency.euro') },
      { value: 'CHF', text: this.$t('currency.chf') },
      { value: 'ISK', text: this.$t('currency.isk') },
      { value: 'CZK', text: this.$t('currency.czk') },
    ];
  }

  get walleeCredentials() {
    return [
      { name: 'userId', type: InputType.Text, label: 'venue.form.userId', autocomplete: 'off' },
      { name: 'spaceId', type: InputType.Text, label: 'venue.form.spaceId', autocomplete: 'off' },
      { name: 'userKey', type: InputType.Text, label: 'venue.form.userKey', autocomplete: 'off' },
    ];
  }

  get walleePaymentConfs() {
    return [
      { name: 'reka', type: InputType.Text, label: 'venue.form.reka' },
      { name: 'twint', type: InputType.Text, label: 'venue.form.twint' },
      { name: 'boncard', type: InputType.Text, label: 'venue.form.boncard' },
      { name: 'luncheck', type: InputType.Text, label: 'venue.form.luncheck' },
      { name: 'postfinance', type: InputType.Text, label: 'venue.form.postfinance' },
      { name: 'postfinance_card', type: InputType.Text, label: 'venue.form.postfinanceCard' },
      { name: 'wechat', type: InputType.Text, label: 'venue.form.wechat' },
      { name: 'alipay', type: InputType.Text, label: 'venue.form.alipay' },
      { name: 'worldline', type: InputType.Text, label: 'venue.form.worldline' },
    ];
  }

  get worldlineCredentials() {
    return [
      { name: 'apiKey', type: InputType.Text, label: 'venue.form.apiKey', autocomplete: 'off' },
      { name: 'apiSecret', type: InputType.Text, label: 'venue.form.apiSecret', autocomplete: 'off' },
      { name: 'pspId', type: InputType.Text, label: 'venue.form.pspId', autocomplete: 'off' },
    ];
  }

  get datatransCredentials() {
    return [
      {
        name: 'dataTransMerchantId',
        type: InputType.Text,
        label: 'venue.form.dataTransMerchantId',
        autocomplete: 'off',
      },
      {
        name: 'dataTransMerchantPassword',
        type: InputType.Text,
        label: 'venue.form.dataTransMerchantPassword',
        autocomplete: 'off',
      },
      {
        name: 'dataTransMerchantWebhookKey',
        type: InputType.Text,
        label: 'venue.form.dataTransMerchantWebhookKey',
        autocomplete: 'off',
      },
    ];
  }

  get adyenCredentials() {
    return [
      { name: 'apiKey', type: InputType.Text, label: 'venue.form.apiKey', autocomplete: 'off' },
      { name: 'urlPrefix', type: InputType.Text, label: 'venue.form.urlPrefix', autocomplete: 'off' },
      { name: 'merchantAccount', type: InputType.Text, label: 'venue.form.merchantAccount', autocomplete: 'off' },
      { name: 'clientKey', type: InputType.Text, label: 'venue.form.clientKey', autocomplete: 'off' },
    ];
  }

  get neptingCredentials() {
    return [
      { name: 'merchantId', type: InputType.Text, label: 'venue.form.merchantId', autocomplete: 'off' },
      {
        name: 'brandId',
        type: InputType.Text,
        label: 'venue.form.externalOrderProviders.brandId',
        autocomplete: 'off',
      },
      { name: 'secretKey', type: InputType.Password, label: 'venue.form.secretKey', autocomplete: 'off' },
      { name: 'username', type: InputType.Text, label: 'venue.form.username', autocomplete: 'off' },
      { name: 'password', type: InputType.Password, label: 'venue.form.password', autocomplete: 'off' },
    ];
  }

  get ppdAuthorized() {
    return (
      this.initValues &&
      this.initValues?.ppEmailConfirmed &&
      !!this.initValues?.ppMerchantId &&
      !!this.initValues?.ppSecretKey &&
      !!this.initValues?.ppEmail
    );
  }

  get ppReceivable() {
    return (
      this.initValues &&
      this.initValues?.ppPaymentsReceivable &&
      !!this.initValues?.ppMerchantId &&
      !!this.initValues?.ppSecretKey &&
      !!this.initValues?.ppEmail
    );
  }

  public onAdyenEnabledChange(val: boolean) {
    if (!val) {
      this.adyenPaypalEnabled = false;
    }

    this.adyenEnabled = val;
  }

  public created() {
    this.adyenEnabled = !!(this.initValues as any)?.adyenEnabled;
    this.adyenPaypalEnabled = !!(this.initValues as any)?.adyenPaypalEnabled;
  }

  public getData() {
    const data: Partial<Venue> = {
      ...this.$refs.baseForm.form,
      ...this.$refs.deliveryForm.form,
      ...this.$refs.preorderForm.form,
      ...this.$refs.paymentForm.form,
      ...this.$refs.ccForm.form,
      ...this.$refs.ppForm.form,
      ...this.$refs.sepaForm.form,
      ...this.$refs.sbForm.form,
      ...this.$refs.apForm.form,
      ...this.$refs.gpForm.form,
      ...this.$refs.datatransCredentials?.form,
      walleeCredentials: {
        ...this.$refs.walleeCredentials.form,
      },
      walleePaymentConfs: {
        ...this.$refs.walleePaymentConfs.form,
      },
      worldlineCredentials: {
        ...this.$refs.worldlineCredentials.form,
      },
      adyenCredentials: {
        ...this.$refs.adyenCredentials?.form,
      },
      nepting: {
        ...this.$refs.neptingCredentials?.form,
      },
      ...{ adyenPaypalEnabled: this.adyenPaypalEnabled },
    };

    delete data.ppEmailConfirmed;
    delete data.ppPaymentsReceivable;

    return data;
  }
}
